var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Chain.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const Chain = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M3.9602 11.38C4.2402 9.91 5.6202 8.9 7.1202 8.9H10.0502C10.5702 8.9 11.0002 8.47 11.0002 7.95C11.0002 7.43 10.5702 7 10.0502 7H7.2202C4.6102 7 2.2802 8.91 2.0302 11.51C1.7402 14.49 4.0802 17 7.0002 17H10.0502C10.5702 17 11.0002 16.57 11.0002 16.05C11.0002 15.53 10.5702 15.1 10.0502 15.1H7.0002C5.0902 15.1 3.5802 13.36 3.9602 11.38ZM9.0002 13H15.0002C15.5502 13 16.0002 12.55 16.0002 12C16.0002 11.45 15.5502 11 15.0002 11H9.0002C8.4502 11 8.0002 11.45 8.0002 12C8.0002 12.55 8.4502 13 9.0002 13ZM16.7802 7H13.9502C13.4302 7 13.0002 7.43 13.0002 7.95C13.0002 8.47 13.4302 8.9 13.9502 8.9H16.8802C18.3802 8.9 19.7602 9.91 20.0402 11.38C20.4202 13.36 18.9102 15.1 17.0002 15.1H13.9502C13.4302 15.1 13.0002 15.53 13.0002 16.05C13.0002 16.57 13.4302 17 13.9502 17H17.0002C19.9202 17 22.2602 14.49 21.9802 11.51C21.7302 8.91 19.3902 7 16.7802 7Z",
    fill: color
  })
});